import type { NodeEntry } from 'slate';

import type { RenderTextOptions } from './text';
import { renderText } from './text';
import { isInsertTabEdit, isRemoveTabEdit, measureText } from '../../slate-api';
import type { RenderModelTab } from '../../slate-api';
import type { RenderContext } from '../engine/render-context';

export function renderTab(
  renderContext: RenderContext,
  rMTabEntry: NodeEntry<RenderModelTab>,
  options: RenderTextOptions
) {
  const { editor } = renderContext;
  const [rMTab] = rMTabEntry;
  const { options: tabOptions = {}, tabWidthPx } = rMTab;
  const suggestedEdits = rMTab.suggestedEdits ?? [];
  const { leader = 'none' } = tabOptions;

  const leaderChar: string | null = {
    dot: '.',
    hyphen: '-',
    middleDot: '·',
    none: null,
    underscore: '_',
  }[leader];

  const leaderCharWidth = leaderChar
    ? measureText(editor, {
        text: leaderChar,
        textNode: rMTab.children[0],
      })
    : null;

  const leaderCharCount = leaderCharWidth ? Math.floor(tabWidthPx / leaderCharWidth) : 0;
  const leaderChars = leaderChar?.repeat(leaderCharCount) ?? '';

  renderContext.renderChildren(rMTabEntry, { text: renderText }, {
    ...options,
    inheritDeleteEdit: suggestedEdits.find(isRemoveTabEdit),
    inheritInsertEdit: suggestedEdits.find(isInsertTabEdit),
    inlineVoid: {
      caret: 'end',
      overrideWidthPx: tabWidthPx,
      showText: true,
    },
    overrideText: leaderChars,
  } satisfies RenderTextOptions);
}
